export const ownProgressive = [
  {
    name: 'Akcesoria',
    link: '/buy-accessories',
  },
  {
    name: 'Korpusy',
    link: '/buy-wardrobe-body',
  },
];

export const slidePoints = [50, 75, 100, 120, 150, 170, 180, 200, 220, 240, 260];
